export default __webpack_public_path__ + "static/slider-ks-mobile-5da1db879cc1d61e59153cb0912489cf.jpg";